export default "__VITE_ASSET__7S$hRs$e__"